<template>
  <div class="widget-attachment-one-line-layout">
    <div class="widget-attachment-one-line-layout__image">
      <widget-file-mime-icon
        class="widget-attachment-one-line-layout__icon"
        :mime-type="mimeType"
      />
    </div>

    <div class="widget-attachment-one-line-layout__content">
      <widget-attachment-full-name
        class="widget-attachment-one-line-layout__full-name"
        :name="name"
      />

      <div class="widget-attachment-one-line-layout__details">
        {{ sizeLabel }}
        <slot name="message-info-compensator" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import WidgetFileMimeIcon from '@widgets/shared/components/WidgetFileMimeIcon.vue'
import WidgetAttachmentFullName from '@widgets/shared/components/attachment/WidgetAttachmentFullName.vue'
import { getFileSizeLabel } from '@/utils/file/getFileSizeLabel'
import { computed } from '@/composition/vue/compositionApi'

const { mimeType, name, size } = defineProps<{
  mimeType: string // application/pdf
  name: string // file.pdf
  size: number // in bytes
}>()

const sizeLabel = computed(() => getFileSizeLabel(size))
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.widget-attachment-one-line-layout {
  display: flex;
  gap: 6px;
  align-items: center;
  color: $neutral;
  font-weight: $regular-font;

  &__image {
    flex-shrink: 0;
    flex-grow: 0;
    line-height: 0;
  }

  &__icon {
    width: 22px;
    height: 22px;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 1;
    flex-grow: 1;
    min-width: 0;
  }

  &__full-name {
    flex-shrink: 1;
    flex-grow: 0;
    min-width: 0;
  }

  &__details {
    flex-shrink: 0;
    flex-grow: 0;
    font-size: 12px;
    line-height: 16px;
    color: $distinct;
  }
}
</style>
